import { useState } from 'react'
import { ChevronDownIcon } from '@radix-ui/react-icons'

interface CompanyPageAccordionProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  stickyHeader?: boolean
  stickyTopOffset?: number
  headerRight?: React.ReactNode
}

export function CompanyPageAccordion({
  title,
  children,
  defaultOpen = true,
  stickyHeader = false,
  stickyTopOffset = 0,
  headerRight,
}: CompanyPageAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 shadow-md">
      {/* Accordion Header */}
      <div
        className={`${stickyHeader ? 'sticky bg-gray-50 z-40 rounded-t-lg before:absolute before:inset-x-0 before:top-0 before:-translate-y-full before:h-4 before:bg-gradient-to-t before:from-gray-50 before:to-transparent before:pointer-events-none' : ''} p-4 relative`}
        style={
          stickyHeader
            ? {
                top: stickyTopOffset
                  ? `${stickyTopOffset}px`
                  : 'var(--company-top-card-height, 0px)',
              }
            : undefined
        }
      >
        <div className="flex items-center justify-between w-full gap-4">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center gap-2 text-left focus:outline-none"
          >
            <ChevronDownIcon
              className={`w-5 h-5 text-green-700 transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`}
            />
            <span className="text-sm font-light tracking-widest text-gray-900 uppercase">
              {title}
            </span>
          </button>
          {headerRight && (
            <div className="flex items-center gap-2">{headerRight}</div>
          )}
        </div>
      </div>

      {/* Accordion Content */}
      {isOpen && <div className="px-4 pb-4">{children}</div>}
    </div>
  )
}
